module.exports = file => require('@/components/' + file + '.vue').default


// WEBPACK FOOTER //
// ./src/router/_import.js